import React from "react";

// Decorative animated SVG showing motherboard traces + firing synapses.
// Sits behind content, purely visual, no interactivity.
export default function SynapseBackground({ intensity = 0.5 }) {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
      data-testid="synapse-background"
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1200 800"
        preserveAspectRatio="xMidYMid slice"
        style={{ opacity: intensity }}
      >
        <defs>
          <linearGradient id="lg1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#00F0FF" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#8B5CF6" stopOpacity="0.25" />
          </linearGradient>
          <radialGradient id="glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#00F0FF" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#00F0FF" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* Circuit-board style paths */}
        {[
          "M0,120 L200,120 L260,180 L520,180 L580,240 L900,240 L960,180 L1200,180",
          "M0,320 L140,320 L200,380 L420,380 L480,320 L720,320 L780,380 L1200,380",
          "M0,560 L220,560 L280,620 L560,620 L620,560 L860,560 L920,620 L1200,620",
          "M0,720 L180,720 L240,660 L540,660 L600,720 L820,720 L880,660 L1200,660",
        ].map((d, i) => (
          <path
            key={i}
            d={d}
            fill="none"
            stroke="url(#lg1)"
            strokeWidth="1.2"
            className="pulse-line"
            style={{ animationDelay: `${i * 1.3}s` }}
          />
        ))}

        {/* Synapse nodes / sparks */}
        {[
          [200, 120], [520, 180], [900, 240], [200, 380], [720, 320],
          [280, 620], [620, 560], [180, 720], [820, 720], [960, 180],
          [420, 380], [560, 620], [880, 660],
        ].map(([x, y], i) => (
          <g key={i}>
            <circle cx={x} cy={y} r="20" fill="url(#glow)" className="spark" style={{ animationDelay: `${i * 0.35}s` }} />
            <circle cx={x} cy={y} r="2.5" fill="#00F0FF" />
          </g>
        ))}

        {/* Neuron dendrite curls */}
        <path
          d="M100,50 C160,90 180,140 130,170 C90,200 130,240 190,220"
          fill="none"
          stroke="#FF3C7E"
          strokeOpacity="0.22"
          strokeWidth="1"
          className="pulse-line"
        />
        <path
          d="M1050,50 C990,90 970,140 1020,170 C1060,200 1020,240 960,220"
          fill="none"
          stroke="#8B5CF6"
          strokeOpacity="0.25"
          strokeWidth="1"
          className="pulse-line"
        />
      </svg>
    </div>
  );
}
